/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import { withTranslation } from 'react-i18next';

import { Grid, Card, CardContent } from '@material-ui/core';

import ForgottenPasswordFormComponent from '../../components/Forms/ForgottenPasswordFormComponent';
import { useThemeData } from '../../context/ThemeDataContext'

function ForgottenPassword(props) {
  const {font_family, primary_color_2} = useThemeData().themeData.site.theme;
  return (
    <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{
      fontFamily: `${font_family}`,
      color: `${primary_color_2}`
    }}>
      <Card style={{
        fontFamily: `${font_family}`,
        color: `${primary_color_2}`
      }}>
        <CardContent className="contact-text">
          <Grid container direction="row">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="contact-text">
              <ForgottenPasswordFormComponent {...props} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default React.memo(withTranslation(['message', 'register'])(ForgottenPassword));
